import BaseSportPage from '../components/shared/BaseSportPage';
export default function IceHockey() {
  return <BaseSportPage sport="hockey" label="Ice Hockey" />;
}
